<template lang="pug">
  v-row(v-else key="content")
    v-col(cols="12")
      div
        v-list-item(class="pl-0")
          v-list-item-content
            v-list-item-title
              h1(class="mb-2") Часто задаваемые вопросы

          v-list-item-action
            v-btn(
              v-if="isOrganization"
              @click="openAddCategoryDialog"
              color="success"
              class="px-3"
              rounded
            )
              v-icon(class="mr-1" small) mdi-plus
              | Добавить категорию

          v-list-item-action
            v-btn(
              v-if="isOrganization"
              @click="openAddQuestionDialog"
              color="success"
              class="px-3"
              rounded
            )
              v-icon(class="mr-1" small) mdi-plus
              | Добавить вопрос
        v-slide-y-reverse-transition(mode="out-in")
          sdo-loader(v-if="loading" key="loading")
          v-row(v-if="!loading")
            v-col(cols="12")
              v-expansion-panels(accordion)
                v-slide-x-reverse-transition(
                  group
                  tag="div"
                  class="v-item-group v-expansion-panels v-expansion-panels--accordion"
                )
                  v-expansion-panel(
                    v-for="cat in categories"
                    :key="cat.id"
                  )
                    v-expansion-panel-header
                      strong.mb-0 {{ cat.name }}
                      v-btn.mx-2(
                        v-if="isOrganization"
                        @click.stop="editCategory(cat)"
                        style="flex: 0 1 auto"
                        color="warning"
                        x-small fab
                      )
                        v-icon() mdi-pencil

                      v-btn.mx-2(
                        v-if="isOrganization"
                        @click.stop="deleteCategory(cat)"
                        style="flex: 0 1 auto"
                        color="error"
                        x-small fab
                      )
                        v-icon() mdi-delete
                    v-expansion-panel-content
                      v-list-item(
                        v-if="cat.questions.length"
                        v-for="question in cat.questions"
                        :key="question.id"
                      )
                        v-list-item-title
                          a(
                            @click="openViewQuestionDialog(question)"
                            class="info--text"
                          ) {{ question.question }}

                        v-list-item-action
                          v-btn(
                            v-if="isOrganization"
                            @click.stop="editQuestion(question)"
                            color="warning"
                            fab x-small
                          )
                            v-icon mdi-pencil
                        v-list-item-action
                          v-btn(
                            v-if="isOrganization"
                            @click.stop="deleteQuestion(question)"
                            color="error"
                            fab x-small
                          )
                            v-icon mdi-delete
                      v-list-item(
                        v-if="!cat.questions.length"
                        key="empty"
                      )
                        v-list-item-subtitle В данной категории пока нет вопросов :(

            p.mt-4 Если вы не нашли ответ на свой вопрос, обратитесь в техническую поддержку.

        create-question-dialog(
          v-model="showAddQuestionDialog"
          :question="activeQuestion"
          :categories="categories"
          @question:add="addQuestionToList($event)"
          @question:update="getFaqQuestions()"
        )

        create-category-dialog(
          v-model="showAddCategoryDialog"
          :category="activeCategory"
          @category:add="addCategoryToList($event)"
          @category:update="getFaqQuestions()"
        )

        delete-dialog(
          v-model="showDeleteCategoryDialog"
          @delete="onCategoryDelete"
          :request="$api.faq.categories.delete"
          :request-id="activeCategory.id"
        )
          template(v-slot:body="") Вы действительно хотите удалить данную категорию?

        delete-dialog(
          v-model="showDeleteQuestionDialog"
          @delete="onQuestionDelete"
          :request="$api.faq.questions.delete"
          :request-id="activeQuestion.id"
        )
          template(v-slot:body="") Вы действительно хотите удалить данный вопрос?

        view-question-dialog(
          v-model="showViewQuestionDialog"
          :question="activeQuestion"
          :categories="categories"
          @question:add="addQuestionToList($event)"
          @question:update="getFaqQuestions()"
        )

</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { VExpansionPanels } from 'vuetify/lib';

import CreateQuestionDialog from '@/modules/FAQ/components/CreateQuestionDialog.vue';
import CreateCategoryDialog from '@/modules/FAQ/components/CreateCategoryDialog.vue';

import ViewQuestionDialog from '@/modules/FAQ/components/ViewQuestionDialog.vue';

Vue.component('VExpansionPanels', VExpansionPanels);

export default {
  name: 'FAQList',
  components: {
    ViewQuestionDialog, CreateQuestionDialog, CreateCategoryDialog, VExpansionPanels,
  },
  data: () => ({
    categories: [],
    showAddQuestionDialog: false,
    showAddCategoryDialog: false,
    showDeleteQuestionDialog: false,
    showDeleteCategoryDialog: false,
    showViewQuestionDialog: false,
    activeQuestion: {},
    activeCategory: {},
    loading: false,
  }),
  computed: {
    ...mapGetters({ isOrganization: 'auth/isOrganization' }),
  },
  mounted() {
    this.getFaqQuestions();
  },
  methods: {
    openViewQuestionDialog(question) {
      this.activeQuestion = question;
      this.showViewQuestionDialog = true;
    },
    openAddQuestionDialog() {
      this.activeQuestion = {
        question: '',
        answer: '',
        faq_category_id: 0,
      };
      this.showAddQuestionDialog = true;
    },
    openAddCategoryDialog() {
      this.activeCategory = {
        name: '',
        questions: [],
      };
      this.showAddCategoryDialog = true;
    },
    editQuestion(question) {
      this.activeQuestion = { ...question };
      this.showAddQuestionDialog = true;
    },
    deleteQuestion(question) {
      this.activeQuestion = { ...question };
      this.showDeleteQuestionDialog = true;
    },
    onQuestionDelete() {
      this.showDeleteQuestionDialog = false;
      this.getFaqQuestions();
    },
    editCategory(category) {
      this.activeCategory = { ...category };
      this.showAddCategoryDialog = true;
    },
    deleteCategory(category) {
      this.activeCategory = { ...category };
      this.showDeleteCategoryDialog = true;
    },
    onCategoryDelete() {
      this.showDeleteCategoryDialog = false;
      this.getFaqQuestions();
    },
    getFaqQuestions() {
      this.loading = true;
      this.$rHandler(
        this.$api.faq.questions.index(),
        (r) => {
          this.categories = r.data.data.categories;
          this.loading = false;
        },
      );
    },
    addQuestionToList(question) {
      try {
        this.categories
          .find((cat) => cat.id === question.faq_category_id)
          .questions.push(question);
      } catch (e) {
        console.error('Ошибка при добавлении категории в DOM: ', e);
      }
    },
    addCategoryToList(category) {
      this.categories.push(category);
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-expansion-panel--active .v-expansion-panel-header {
    min-height: unset;
  }

  .v-expansion-panel::before {
    box-shadow: none;
  }

  strong {
    font-weight: 600;
  }

</style>
